import { useState } from 'react';
import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_SERVICE_ID = 'service_njhiff3';
const EMAILJS_TEMPLATE_ID = 'template_kbed0qf';
const EMAILJS_PUBLIC_KEY = 'Vwkd1Q-0WYSosDkkn';

// Initialize EmailJS
emailjs.init(EMAILJS_PUBLIC_KEY);

/**
 * Custom hook to handle contact form submission via EmailJS
 * @returns {Object} Form state and handlers
 */
export const useContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setStatus({ loading: true, success: false, error: null });

    try {
      // Template parameters matching the EmailJS template
      const templateParams = {
        name: formData.name,
        email: formData.email,
        message: `${formData.subject ? `Oggetto: ${formData.subject}\n\n` : ''}${formData.message}`
      };

      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams
      );

      console.log('SUCCESS!', response.status, response.text);
      
      setStatus({ loading: false, success: true, error: null });
      
      // Reset form after successful submission
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });

      return { success: true, response };
    } catch (error) {
      console.error('FAILED...', error);
      
      setStatus({ 
        loading: false, 
        success: false, 
        error: 'Si è verificato un errore durante l\'invio del messaggio. Riprova più tardi.' 
      });

      return { success: false, error };
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
    setStatus({ loading: false, success: false, error: null });
  };

  return {
    formData,
    status,
    handleChange,
    handleSubmit,
    resetForm
  };
};
